import { actionTypes, workplaceTypes } from "../types";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'

import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { VehicleNumberBlock } from "../Block/VehicleNumberBlock";
import { appNotification } from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { cache } from '@/components/Cache.js';
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';

export const ProfilePage = {
    controller: function () {
        var self = this;
        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        if (user.get('state.workplace') === workplaceTypes.driver) {
            this.topMenu = [
                { title: 'Задачи', url: '/vehicle/tasks', icon: 'fa-tasks' },
                { title: 'Техника', url: '/vehicle', icon: 'fa-truck' }
            ];
            if (user.get('state.vehicleFreeTasksAvailable')) {
                this.topMenu.unshift(
                    { title: 'Свободные', url: '/vehicle/tasks/free', icon: 'fa-car' }
                )
            }
        } else if (user.get('state.workplace') === workplaceTypes.security) {
            this.topMenu = [
                { title: 'Рейсы', url: '/security/flights', icon: 'fa-plane' }
            ]
        } else if (user.get('state.workplace') === workplaceTypes.agent) {
            this.topMenu = [
                { title: 'Задачи', url: '/agent/tasks', icon: 'fa-tasks' },
                { title: 'Рейсы', url: '/agent/flights', icon: 'fa-plane' }
            ]
        } else {
            this.topMenu = [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' }
            ]
        }

        this.topMenu.push({ title: 'Профиль', url: '/profile', icon: 'fa-user' });
        if (isEnabledMsg())
            this.topMenu.push({ title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' });
        this.topMenu.push({ title: 'Выйти', url: '/logout', icon: 'fa-sign-out' });



        let arr = Object.values(user.get('workplaces'));
        this.changeRoleAvailable = (arr.length > 1);

        this.data = m.request({
            method: 'GET',
            url: '/api/profile'
        }).then(function (response) {
            server.setOnline();
            loader.hide();
            storage.config = response.config;

            appNotification.list = response.notifications;

            server.initPing();
            appNotification.init();

            return response;
        }, function (response) {
            if (response && response.message) {
                self.errmsg = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });

        this.changePassword = function (e) {
            e.preventDefault();
            self.errmsg = '';
            loader.show();

            var data = {
                password: e.target.password.value,
                newPassword: e.target.newPassword.value
            };

            if (data.newPassword !== e.target.newConfirmPassword.value) {
                self.errmsg = (m(".alert.alert-danger", 'Повторный новый пароль введен неверно'));
                loader.hide();
                return false;
            }

            m.request({
                method: 'PUT',
                url: '/api/profile',
                data: data
            }).then(function () {
                loader.hide();
                m.route('/logout');
            }, function (response) {

                data.type = actionTypes.passwordChange;
                cache.push(data);

                if (response && response.message) {
                    self.errmsg = (m(".alert.alert-danger", response.message));
                } else {
                    server.setOffline();
                }
                loader.hide();
            });
        }
    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: ctrl.data().time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", VehicleNumberBlock()),
            m(".container[style='padding-top:15px']", [
                ctrl.errmsg,
                (ctrl.changeRoleAvailable)
                    ? m("div[style='padding-bottom:15px']", [
                        m("a.btn.btn-primary.btn-block.btn-lg", {
                            href: '/workplace',
                            config: m.route
                        }, [
                            m("i.fa.fa-exchange"),
                            m.trust("&nbsp;Сменить роль")
                        ])
                    ])
                    : '',
                (storage.config.ActiveDirectoryAuth)
                    ? ''
                    : m("form", { onsubmit: ctrl.changePassword.bind(ctrl) },
                        [
                            m("div.form-group",

                                [
                                    m("input.form-control.input-lg[type='text'][name='password'][placeholder='Введите текущий пароль'][autocomplete='off'][required][style='margin-bottom:6px']"),
                                    m("input.form-control.input-lg[type='password'][name='newPassword'][placeholder='Введите новый пароль'][autocomplete='off'][required][style='margin-bottom:6px']"),
                                    m("input.form-control.input-lg[type='password'][name='newConfirmPassword'][placeholder='Повторите новый пароль'][autocomplete='off'][required]")
                                ]
                            ),
                            m("div.form-group", [
                                m("button.btn.btn-info.btn-block.btn-lg[type='submit']", "Отправить")
                            ])
                        ]
                    )
            ])
        ];
    }
};
